import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsDetailsStep.StepForm', {
    provideVerificationData:
        'Please provide verification data for the selected persons. Verification link will be automatically send to the selected person in order to complete data verification.',
});
